import { faEye } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { GraphTimeWindow } from './elements/types';
import type { PreviewRenderContext } from './previewContextFactory';
import { formatReportPeriod } from './runtime/dataServices/report/service';
import { SwarmTypeBadges } from './SwarmTypeBadges';

interface PreviewContextSummaryProps {
    context: PreviewRenderContext;
    range: GraphTimeWindow;
    timezone: string;
    onOpen: () => void;
}

/** Keeps the current preview context visible while scrolling through the template. */
export function PreviewContextSummary({
    context,
    range,
    timezone,
    onOpen,
}: PreviewContextSummaryProps): JSX.Element {
    const isProject = context.kind === 'project';
    const name = isProject ? context.project.name : context.measuringPoint.name;
    const deviceName = isProject ? null : context.measuringPoint.deviceName;

    return (
        <div className="pointer-events-none sticky bottom-4 z-40 mt-4 flex justify-center">
            <button
                type="button"
                onClick={onOpen}
                title={gettext('PREVIEW_CONTEXT')}
                className="pointer-events-auto flex max-w-full items-center gap-x-2 rounded-full border border-neutral-300 bg-white px-4 py-2 text-sm text-gray-700 shadow-lg hover:bg-neutral-50"
            >
                <FontAwesomeIcon icon={faEye} className="text-primary shrink-0" />
                <span className="truncate">{deviceName ? `${name} (${deviceName})` : name}</span>
                {!isProject && (
                    <SwarmTypeBadges supportedSwarmTypes={[context.measuringPoint.swarmType]} />
                )}
                <span className="hidden shrink-0 sm:inline">
                    {formatReportPeriod(timezone, range).period}
                </span>
            </button>
        </div>
    );
}
